import React from "react";

export const FilledTriangleWarning = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clip-path="url(#clip0_720_82793)">
      <path
        d="M14.7999 11.7556L9.33431 2.26376C9.19773 2.03121 9.00275 1.8384 8.76869 1.70442C8.53463 1.57045 8.26963 1.49997 7.99994 1.49997C7.73025 1.49997 7.46524 1.57045 7.23118 1.70442C6.99713 1.8384 6.80214 2.03121 6.66556 2.26376L1.19994 11.7556C1.06852 11.9806 0.999268 12.2364 0.999268 12.4969C0.999268 12.7574 1.06852 13.0132 1.19994 13.2381C1.33477 13.4721 1.52942 13.666 1.76391 13.7998C1.99841 13.9337 2.2643 14.0028 2.53431 14H13.4656C13.7354 14.0026 14.001 13.9334 14.2353 13.7995C14.4695 13.6656 14.664 13.4719 14.7987 13.2381C14.9303 13.0133 14.9998 12.7576 15 12.4971C15.0002 12.2366 14.9312 11.9807 14.7999 11.7556ZM7.49994 6.50001C7.49994 6.3674 7.55262 6.24023 7.64638 6.14646C7.74015 6.05269 7.86733 6.00001 7.99994 6.00001C8.13255 6.00001 8.25972 6.05269 8.35349 6.14646C8.44726 6.24023 8.49994 6.3674 8.49994 6.50001V9.00001C8.49994 9.13262 8.44726 9.2598 8.35349 9.35356C8.25972 9.44733 8.13255 9.50001 7.99994 9.50001C7.86733 9.50001 7.74015 9.44733 7.64638 9.35356C7.55262 9.2598 7.49994 9.13262 7.49994 9.00001V6.50001ZM7.99994 12C7.8516 12 7.7066 11.956 7.58326 11.8736C7.45992 11.7912 7.36379 11.6741 7.30703 11.537C7.25026 11.4 7.23541 11.2492 7.26435 11.1037C7.29329 10.9582 7.36472 10.8246 7.46961 10.7197C7.5745 10.6148 7.70813 10.5434 7.85362 10.5144C7.99911 10.4855 8.14991 10.5003 8.28695 10.5571C8.42399 10.6139 8.54113 10.71 8.62354 10.8333C8.70595 10.9567 8.74994 11.1017 8.74994 11.25C8.74994 11.4489 8.67092 11.6397 8.53027 11.7803C8.38962 11.921 8.19885 12 7.99994 12Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_720_82793">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
